export interface CreateAccountsRequest {
  firstNameEn: string;
  lastNameEn: string;
  workingEmail: string;
  positionAlias: string;
  employeeId?: string;
  candidateId?: number;
  employeeType?: string;
  privateNotePassword: string;
  azureId?: string;
}

export interface DeprovisionEntityRequest {
  employeeId?: string;
  candidateId?: number;
}

export interface DeprovisionAccountsRequest extends DeprovisionEntityRequest {
  deprovisionAzureAccount?: boolean;
  deprovisionRedmineAccount?: boolean;
  deprovisionGitlabAccount?: boolean;
  deprovisionDavinciAccount?: boolean;
}

export interface CreateRedmineUserAccountRequest {
  firstNameEn: string;
  lastNameEn: string;
  workingEmail: string;
  positionAlias?: string;
  employeeType?: string;
  azureId?: string;
}

export interface RedmineAccountCreationStatus {
  userId?: number;
  email?: string;
  url?: string;
  errors: string[];
}

export interface RedmineGroupsAssignmentStatus {
  attemptedToModifyGroups: boolean;
  currentJoinedGroups: string[];
  errors: string[];
}

export interface AzureGroupsAssignmentStatus {
  attemptedToModifyGroups: boolean;
  currentJoinedGroups: string[];
  errors: string[];
}

export interface DaVinciAccountModificationStatus {
  attemptedModifyAccount: boolean;
  errors: string[];
}

export enum DeprovisionStatus {
  NOT_PERFORMED = 'NOT_PERFORMED',
  OK = 'OK',
  ERROR = 'ERROR',
  NOT_FOUND = 'NOT_FOUND',
}

export interface AccountDeprovisionStatus {
  status: DeprovisionStatus;
  errors: string[];
}

export interface DeprovisionAccountsResponse {
  azureDeprovisionStatus: AccountDeprovisionStatus;
  redmineDeprovisionStatus: AccountDeprovisionStatus;
  gitlabDeprovisionStatus: AccountDeprovisionStatus;
  employeeDeprovisionStatus: AccountDeprovisionStatus;
  candidateDeprovisionStatus: AccountDeprovisionStatus;
}

export interface CreateRedmineUserAccountResponse {
  accountCreation: RedmineAccountCreationStatus;
  groupsAssignment: RedmineGroupsAssignmentStatus;
}

export interface CreateAzureUserAccountRequest {
  firstNameEn: string;
  lastNameEn: string;
  workingEmail: string;
  employeeId?: string;
  candidateId?: number;
  employeeType?: string;
  azureId?: string;
  positionAlias?: string;
  privateNotePassword: string;
}

export interface AzureAccountCreationResponse {
  userId?: string;
  firstNameEn?: string;
  lastNameEn?: string;
  positionAlias?: string;
  workingEmail?: string;
  errors: string[];
}

export interface LicenseAssignmentResponse {
  attemptedToAssignLicense?: boolean;
  errors: string[];
}

export interface PrivateNoteCreationResponse {
  attemptedToCreatePrivateNote?: boolean;
  errors: string[];
}

export interface CreateAzureUserAccountResponse {
  accountCreation: AzureAccountCreationResponse;
  licenseAssignment: LicenseAssignmentResponse;
  groupsAssignment: AzureGroupsAssignmentStatus;
  davinciAccountModification: DaVinciAccountModificationStatus;
  privateNoteCreation?: PrivateNoteCreationResponse;
  privateNoteUrl?: string;
}

export interface AccountsCreationResponse {
  createAzureAccountResponse?: CreateAzureUserAccountResponse;
  createRedmineAccountResponse?: CreateRedmineUserAccountResponse;
}

export interface DaVinciProfileTarget {
  employeeId?: string;
  candidateId?: number;
}

export interface StatusContext {
  errors: any[];
  successes: any[];
  instructions: any[];
}
